import { render, staticRenderFns } from "./CategorySalesTable.vue?vue&type=template&id=7e2185d4&"
import script from "./CategorySalesTable.vue?vue&type=script&lang=js&"
export * from "./CategorySalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports